export const CANCEL_FUTURE_TASK = '/api/profile/homeinternet/cancelfuturetask/';
export const FTTB_STATUS = '/api/profile/homeinternet/status/';
export const DISABLE_SERVICE_CHECK = '/api/profile/homeinternet/disableservicecheck/';
export const DISABLE_SERVICE = '/api/profile/homeinternet/disableservice/';
export const CHANGE_FIREWALL = '/api/profile/homeinternet/changefirewall/';
export const CONNECT_SOCIAL_INTERNET = '/api/profile/homeinternet/ConnectSocialInternet/';
export const GET_POPUP_SOCIAL_INTERNET = '/api/profile/homeinternet/getPopupSocialInternet/';
export const GET_POPUP_ADDITIONAL_SERVICE = '/api/profile/homeinternet/getPopupConnectAdditionalService/';
export const CONNECT_ADDITIONAL_SERVICE = '/api/profile/homeinternet/connectAdditionalService/';
export const CONNECT_ADDITIONAL_SERVICE_PROMISED_PAYMENT = '/api/profile/homeinternet/connectAdditionalServicePromisedPayment/';

export const GET_WIFI_ROUTER_RETURN_INFO = '/api/profile/homeinternet/wifiRouterReturnInfo';
